"use client";
import {Button} from "@/components/ui/button";
import CWFSheet from "@/components/ui/CWFSheet";
import {useState} from "react";
import Avatar from "@/components/General/Avatar";
import TimePicker from "@/components/Calendar/TimePicker";
import CWFResponsiveSheet from "@/components/ui/CWFResponsiveSheet";
import {Badge} from "@/components/ui/badge";
import ReadMore from "@/components/Utils/ReadMore";

export default function ReservationAction({profile}) {
    const [isOpen, setIsOpen] = useState(false);

    function handleClick(){
        setIsOpen(!isOpen);
    }


    return(
        <>
            <Button disabled={!profile.availability?.availabilities} onClick={() => handleClick()}>Réserver</Button>
            <CWFResponsiveSheet
                trigger={null}
                open={isOpen}
                onOpenChange={setIsOpen}
                title={"Réservez votre séance"}
                className={"w-full md:max-w-2xl  md:w-3/4 overflow-y-scroll"}
            >
                <div className={"flex flex-col items-center pt-5"}>
                    <Avatar url={profile.docs[0]?.path} width={60} height={60}/>
                    <h3 className={"font-bold text-primary"}>{profile.firstname} {profile.lastname}</h3>
                    <p className={"text-xs text-gray-500 italic font-medium"}>{profile.job} {profile.speciality}</p>
                </div>
                <div className={"flex gap-x-4 pb-2"}>
                    <Badge className={"text-white"}>COACHING PRIVÉ</Badge>
                    <p>1h</p>
                </div>
                <ReadMore maxCharCount={100}>
                    {profile.profile?.bio}
                </ReadMore>
                <div className={"flex flex-col w-full border-t-2 pt-2"}>
                    <p className={"font-medium text-sm"}>Détails du prix</p>
                    <div className={"flex justify-between items-center mt-2"}>
                        <p className={"text-gray-500"}>Sous-total</p>
                        <p>{profile.profile?.hourly_rate} € TTC</p>
                    </div>
                    <div className={"flex justify-between items-center p-2 bg-gray-200 rounded-lg font-semibold mt-5"}>
                        <p>Total</p>
                        <p className={"font-semibold text-lg"}>{profile.profile?.hourly_rate} €</p>
                    </div>
                </div>
                {profile.availability?.availabilities ?
                    <TimePicker bookingTimes={JSON.parse(profile.availability.availabilities)} length={60}
                                userId={profile.id} profile={profile} type={"RESU"} />
                    :<></>
                }

            </CWFResponsiveSheet>
        </>
    )
}